import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TechnicalService, SearchResult } from 'src/app/interfaces';

/**
 * Component to group all the information returned by the search
 *
 * @export
 * @class SearchResultComponent
 */
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent {
  /**
   * Results to list
   *
   * @type {SearchResult}
   * @memberof SearchResultComponent
   */
  @Input() results: SearchResult;

  /**
   * Message to show when there are no results
   *
   * @type {string}
   * @memberof SearchResultComponent
   */
  @Input() emptyMessage: string;

  /**
   * Event Emitter to communite with others components
   *
   * @type {EventEmitter<any>}
   * @memberof SearchResultComponent
   */
  @Output() closeResults: EventEmitter<any> = new EventEmitter();

  /**
   * technical service selected
   *
   * @type {TechnicalService}
   * @memberof SearchResultComponent
   */
  technicalService: TechnicalService;

  /**
   * Emit an event with the technical service selected
   *
   * @param {TechnicalService} technicalService
   * @memberof SearchResultComponent
   */
  showItemDetail(technicalService: TechnicalService) {
    this.technicalService = technicalService;

    this.setOpenedWindow(technicalService.id);
  }

  /**
   * Remove selected technical service
   *
   * @memberof SearchResultComponent
   */
  hideItemDetail() {
    this.technicalService = null;

    this.setOpenedWindow(null);
  }

  /**
   * Return to search
   *
   * @memberof SearchResultComponent
   */
  goBack() {
    this.closeResults.emit();
  }

  /**
   * Open marker info window
   *
   * @private
   * @param {number} id
   * @memberof SearchResultComponent
   */
  private setOpenedWindow(id: number) {
    this.results.technicalServices = this.results.technicalServices.map((technicalService: TechnicalService) => {
      technicalService.isOpened = technicalService.id === id;

      return technicalService;
    });
  }
}
